<div class="bmc-delete-cases">

  <div class="bmc-delete-cases-warning bz-space--stack-m">
    <bzg-icon [nameIcon]="'warning'" [size]="24" class="bz-space--inline-m bz-icon-color--warning"></bzg-icon>
    <div class="bmc-delete-cases-warning__messages">
      <h5>{{'DELETE_CASES.TITLE' | translate}}</h5>
      <h5>{{'DELETE_CASES.WARNING' | translate}}</h5>
    </div>
    <bzg-button-primary class="bmc-delete-cases-warning__btn-delete-cases" [disabled]="isInProgressOperation()"
      (click)="delete()">
      {{'DELETE_CASES.BUTTON_ACTION' | translate}}
    </bzg-button-primary>
  </div>

  <div class="bmc-delete-cases-loading bz-color-border--theme-400" *ngIf="isInProgressOperation()">
    <bzg-loading [size]="'m'" class="bmc-delete-cases-loading__text">
      {{'DELETE_CASES.DELETING_CASES' | translate}}</bzg-loading>
  </div>

  <div class="bmc-delete-cases-status bmc-delete-cases-status--error" *ngIf="isFailedOperation()">
    <div class="bmc-delete-cases-status__advice bmc-delete-cases-status__advice--error">
      <span class="bmc-delete-cases-status__advice__text">
        <bzg-icon [nameIcon]="'icon-error'" [size]="22" [color]="'error'" class="bz-space--inline-s"></bzg-icon>
        {{'DELETE_CASES.FAILED_TITLE' | translate}}
      </span>
    </div>
    <div class="bmc-delete-cases-status__label" [ngClass]="['bmc-delete-cases-status__label--active']">
      <span class="bmc-delete-cases-status__label__text">
        {{'GLOBAL.AN_ERROR_HAS_OCCURRED' | translate}}
      </span>
    </div>
  </div>

  <div class="bmc-delete-cases-status bmc-delete-cases-status--success" *ngIf="isSucceededOperation()">
    <div class="bmc-delete-cases-status__advice bmc-delete-cases-status__advice--success">
      <span class="bmc-delete-cases-status__advice__text bz-color--theme-400">
        <bzg-icon [nameIcon]="'icon-boolean'" [size]="22" [color]="'success'" class="bz-space--inline-s"></bzg-icon>
        {{'DELETE_CASES.SUCCESS_TITLE' | translate}}
      </span>
    </div>
    <div class="bmc-delete-cases-status__label">
      <span class="bmc-delete-cases-status__label__text">
        {{'DELETE_CASES.SUCCESS_MSG' | translate}}
      </span>
    </div>
  </div>
</div>